import { AudioBufferChunk } from '../../state/entities/AudioBufferChunk'
import { PositionRange } from '../../types'

export function getAudioBufferChunkPlaybackTime(chunk: AudioBufferChunk, [start, end]: PositionRange) {
  const when = Math.max(0, chunk.start - start)
  let offset = chunk.offset
  let length = chunk.length

  if (start > chunk.start) {
    const delta = start - chunk.start

    length -= delta
    offset += delta
  }

  if (end < chunk.end) {
    length -= chunk.end - end
  }

  return { when, offset, length }
}
